import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ImagePlus, Loader2, Trash2, Download, Share2 } from "lucide-react";
import { api, mediaUrl } from "../../lib/api";
import SelectField from "../../components/os/SelectField";

export default function ModuleAIImage({ moduleKey, item, onRefresh }) {
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState("");
  const [model, setModel] = useState("gemini");
  const [busy, setBusy] = useState(false);
  const imgs = item.imagenes || [];

  const gen = async () => {
    setBusy(true);
    try {
      await api.post(`/mod/${moduleKey}/items/${item.id}/image`, { prompt, model });
      toast.success("Imagen generada con IA");
      setPrompt("");
      onRefresh?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "No se pudo generar la imagen"); }
    finally { setBusy(false); }
  };
  const del = async (id) => { try { await api.delete(`/mod/${moduleKey}/items/${item.id}/image/${id}`); onRefresh?.(); } catch { toast.error("Error"); } };

  return (
    <div className="mt-4 border-t border-navy/10 pt-4 space-y-3" data-testid="module-ai-image">
      <div className="overline text-navy/40">Imágenes con IA</div>
      <textarea rows={2} value={prompt} onChange={(e) => setPrompt(e.target.value)} data-testid="aiimage-prompt"
        placeholder="Describe la imagen (opcional; si lo dejas vacío usamos el brief del evento)"
        className="w-full bg-white border border-navy/10 rounded-lg px-3 py-2 outline-none focus:border-violet text-sm" />
      <div className="flex items-center gap-2">
        <div className="w-44"><SelectField testid="aiimage-model" value={model} options={[{ value: "gemini", label: "Gemini Nano Banana" }, { value: "openai", label: "OpenAI GPT Image 1" }]} onChange={setModel} /></div>
        <button onClick={gen} disabled={busy} className="btn btn-primary" data-testid="aiimage-generate-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ImagePlus className="w-4 h-4" />} Generar imagen
        </button>
      </div>
      {busy && <p className="text-xs text-navy/40">Generando imagen con IA… puede tardar hasta 1 minuto.</p>}
      {imgs.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="aiimage-gallery">
          {imgs.map((im) => (
            <div key={im.id} className="relative group rounded-lg overflow-hidden border border-navy/10">
              <img src={mediaUrl(im.url)} alt={im.prompt} className="w-full h-32 object-cover" />
              <div className="absolute top-1 right-1 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                <button onClick={() => navigate(`/os/social-connect?image=${encodeURIComponent(im.url)}&text=${encodeURIComponent(item.nombre || item.titulo || "")}`)} className="w-6 h-6 rounded bg-white/90 flex items-center justify-center text-violet" title="Enviar a Social Connect" data-testid={`aiimage-social-${im.id}`}><Share2 className="w-3.5 h-3.5" /></button>
                <a href={mediaUrl(im.url)} target="_blank" rel="noreferrer" className="w-6 h-6 rounded bg-white/90 flex items-center justify-center text-navy/70" title="Abrir"><Download className="w-3.5 h-3.5" /></a>
                <button onClick={() => del(im.id)} className="w-6 h-6 rounded bg-white/90 flex items-center justify-center text-destructive" title="Eliminar" data-testid={`aiimage-del-${im.id}`}><Trash2 className="w-3.5 h-3.5" /></button>
              </div>
              <span className="absolute bottom-1 left-1 text-[9px] px-1.5 py-0.5 rounded bg-navy/60 text-white">{im.model === "openai" ? "GPT Image" : "Nano Banana"}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
